import { render, staticRenderFns } from "./payment-type-delivery-melaregalo.vue?vue&type=template&id=352427d2&"
import script from "./payment-type-delivery-melaregalo.vue?vue&type=script&lang=js&"
export * from "./payment-type-delivery-melaregalo.vue?vue&type=script&lang=js&"
import style0 from "./payment-type-delivery-melaregalo.vue?vue&type=style&index=0&id=352427d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports